<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :items-per-page="20"
    :page="page"
    class="elevation-1 tabela-classificacao"
    locale="pt-BR"
    loading-text="Carregando"
    no-data-text="Nenhum dado encontrado"
    :loading="loading"
    :server-items-length="total"
    @update:options="handleFilter"
    :footer-props="{
      'items-per-page-text': 'Itens por página:',
      'items-per-page-options': [20, 50, 100],
      'show-first-last-page': true,
      'show-current-page': true,
      'page-text': pageText,
    }"
  >
    <template v-slot:[`body.prepend`]>
      <tr>
        <template v-for="(header, index) in headers">
          <th :key="index">
            <slot :name="header.value"> </slot>
          </th>
        </template>
      </tr>
    </template>

    <template v-slot:[`item.id`]="{ item }">
      <v-menu
        offset-y
        v-if="checkPermission(['classification.edit', 'classification.delete'])"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn small depressed color="fmq_gray" dark v-bind="attrs" v-on="on">
            Opções <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-if="checkPermission('classification.edit')"
            @click="gotTo(item.id)"
          >
            <v-list-item-title>Editar</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="checkPermission('classification.delete')"
            @click="$emit('excluir', item)"
          >
            <v-list-item-title>Excluir</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>

<script>
import { checkPermission } from "@/utils";
export default {
  name: "ClassificacaoTabela",
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    pageText: {
      type: String,
      default: "-",
    },
  },
  data: () => ({
    formData: {
      orderBy: null,
      orderSorted: null,
      perPage: null,
      page: null,
    },
  }),
  created() {
    this.formData.page = this.page;
  },
  methods: {
    checkPermission,
    handleFilter(event) {
      (this.formData.orderBy = event.sortBy[0]),
        (this.formData.orderSorted = event.sortDesc[0] ? ":desc" : ":asc"),
        (this.formData.perPage = event.itemsPerPage),
        (this.formData.page = event.page);
      this.$emit("handleFilter", this.formData);
    },
    gotTo(id) {
      this.$router.push({ name: "ClassificacaoEditar", params: { id: id } });
    },
  },
};
</script>
<style lang="scss">
.tabela-classificacao tbody tr:nth-of-type(even) {
  background-color: #ffffff;
}

.tabela-classificacao tbody tr:nth-of-type(odd) {
  background-color: #eeeeee;
}
</style>
